import { createFeatureSelector, createSelector } from '@ngrx/store';
import { StudentsState } from '../reducers/students.reducer';
import { STUDENTS_FEATURE_KEY } from '../keys';

const selectState = createFeatureSelector<StudentsState>(STUDENTS_FEATURE_KEY);

export const selectLoaded = createSelector(selectState, (state: StudentsState) => state.loaded);
export const selectLoading = createSelector(selectState, (state: StudentsState) => state.loading);
export const selectStudents = createSelector(selectState, (state: StudentsState) => state.students);
export const selectTotalStudents = createSelector(selectState, (state: StudentsState) => state.total);
export const selectPagination = createSelector(selectState, (state: StudentsState) => state.pagination);
